import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ValidateTokenResponse } from '@app/models/token-validation';
import { LoginService } from '@app/pages/login/services/login.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ValidateSetPasswordLinkGuard  {

  constructor(
    private readonly _router: Router,
    private readonly loginService: LoginService,
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (!route.queryParams.token || !route.queryParams.email) {
      this._router.navigateByUrl("auth/signin");
      return false;
    }
    const payload = {
      token: route.queryParams.token,
      email: route.queryParams.email,
    }

    return this.loginService.validateToken(payload).pipe(
      map((data: ValidateTokenResponse) => data.validToken));
  }

}
